import Project from '@/projects/entities/project';

export default abstract class NodeEvent {

  public project: Project

  constructor(project: Project) {
    this.project = project
  }
}
